import { useEffect } from 'react';
import { t } from 'i18next';
import { WeaveLogoNew } from '@frontend/assets';
import { getUser } from '@frontend/auth-helpers';
import { Icon } from '@frontend/icons';
import { pendo } from '@frontend/tracking';
import { theme } from '@frontend/theme';
import { Button, Heading, useVerticalSlideModal, VerticalSlideModal, Text } from '@frontend/design-system';
import { BeginSetup, PopSelection, ThemeSelection, ViewSelection } from './onboarding-states';
import { useNewUserOnboardingStore } from './store';
import { NewUserOnboardingSteps } from './types';

export const NewUserOnboarding = () => {
  const { currentState } = useNewUserOnboardingStore('currentState', 'setIsNewUserOnboardingComplete');
  const { modalProps: verticalModalProps } = useVerticalSlideModal();
  const { setOpen } = useVerticalSlideModal();
  const userID = getUser()?.userID || '';
  const { setIsNewUserOnboardingComplete } = useNewUserOnboardingStore('setIsNewUserOnboardingComplete');
  const renderGetStartedText = () => {
    return <Heading css={{ textAlign: 'center' }}>{t('Let’s get started!')}</Heading>;
  };

  useEffect(() => {
    pendo.track('new_user_onboarding_flow_seen', {
      userId: userID,
      timestamp: new Date().toISOString(),
    });
  }, [userID]);

  const renderContent = (state: string) => {
    switch (state) {
      case NewUserOnboardingSteps.BEGIN_SETUP:
        return <BeginSetup />;

      case NewUserOnboardingSteps.VIEW_SELECTION:
        return <ViewSelection />;

      case NewUserOnboardingSteps.POP_SELECTION:
        return <PopSelection />;

      case NewUserOnboardingSteps.THEME_SELECTION:
        return <ThemeSelection />;
    }
    return;
  };
  return (
    <VerticalSlideModal {...verticalModalProps} isOpen fullHeight>
      <div
        css={{
          height: '100%',
          padding: `${theme.spacing(3)} ${theme.spacing(2)} 0px}`,
        }}
      >
        <div css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span css={{ height: '24px', width: '130px', display: 'block', marginBottom: theme.spacing(3) }}>
            <WeaveLogoNew />
          </span>
          {currentState !== NewUserOnboardingSteps.BEGIN_SETUP && (
            <Button
              variant='secondary'
              size='large'
              trackingId='new-user-onboarding-header-exit-setup-click'
              css={{ marginBottom: theme.spacing(3) }}
              onClick={() => {
                setIsNewUserOnboardingComplete();
                pendo.enableGuides();
                setOpen(false);
              }}
            >
              <Text
                css={{ color: theme.colors.neutral70, marginLeft: theme.spacing(0.5), fontSize: theme.spacing(1.75) }}
              >
                {t('Exit Setup')}
              </Text>
              <Icon name='log-out-small' />
            </Button>
          )}
        </div>
        {currentState !== NewUserOnboardingSteps.VIEW_SELECTION && renderGetStartedText()}
        {renderContent(currentState)}
      </div>
    </VerticalSlideModal>
  );
};
